export const TZOffset = {
  0: 'Etc/GMT',
  1: 'Etc/GMT-1',
  2: 'Etc/GMT-2',
  3: 'Etc/GMT-3',
  4: 'Etc/GMT-4',
  5: 'Etc/GMT-5',
  6: 'Etc/GMT-6',
  7: 'Etc/GMT-7',
  8: 'Etc/GMT-8',
  9: 'Etc/GMT-9',
  10: 'Etc/GMT-10',
  11: 'Etc/GMT-11',
  12: 'Etc/GMT-12',
  [-1]: 'Etc/GMT+1',
  [-2]: 'Etc/GMT+2',
  [-3]: 'Etc/GMT+3',
  [-4]: 'Etc/GMT+4',
  [-5]: 'Etc/GMT+5',
  [-6]: 'Etc/GMT+6',
  [-7]: 'Etc/GMT+7',
  [-8]: 'Etc/GMT+8',
  [-9]: 'Etc/GMT+9',
  [-10]: 'Etc/GMT+10',
  [-11]: 'Etc/GMT+11',
  [-12]: 'Etc/GMT+12',
};
